import { render } from "./commonLoadingBar.vue?vue&type=template&id=c4bb940e"
import script from "./commonLoadingBar.vue?vue&type=script&lang=js"
export * from "./commonLoadingBar.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Yuting_Shiu\\Desktop\\mes-chunyu-modify\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__